/* eslint-disable react/no-array-index-key */
import {css, useTheme} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import React, {Fragment} from 'react';
import {EntityLink} from 'src/js/containers/file';

export type BreadcrumbItem = {
  iconName: string;
  iconViewBox: string;
  text: string;
  url: string;
  primaryColor?: string;
  secondaryColor?: string;
};
type Props = {
  items: BreadcrumbItem[];
  style?: React.CSSProperties;
};
export const LightBreadcrumbs: React.FC<Props> = (props) => {
  const {items, ...extraProps} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme});

  return (
    <div data-name='light-breadcrumbs' {...extraProps} css={muiStyles.wrapper}>
      {items.map((v, i) => {
        const {primaryColor, secondaryColor} = v;
        const primaryColorCssVar = primaryColor ? {'--dlMultiColorPrimary': primaryColor} : {};
        const secondaryColorCssVar = secondaryColor ? {'--dlMultiColorSecondary': secondaryColor} : {};
        const notClickable = !v.url;
        return (
          <Fragment key={i}>
            {i > 0 && <DlMuiDynamicIcon iconName={'haidiRightArrow'} useFixedViewBox='0 0 8 10' inputCss={muiStyles.joinerIconButton} />}
            <div
              data-name='breadcrumb-item'
              data-not-clickable={notClickable}
              css={muiStyles.item}
              style={{marginLeft: i > 0 ? 8 : 0, marginRight: i < items.length - 1 ? 8 : 0}}
              data-selected={i === items.length - 1}
            >
              <EntityLink route={v.url} searchParams={undefined} suppressPadding notClickable={notClickable}>
                <DlMuiDynamicIcon
                  iconName={v.iconName}
                  useFixedViewBox={v.iconViewBox}
                  css={muiStyles.itemIconButton}
                  svgIconStyle={
                    {
                      ...primaryColorCssVar,
                      ...secondaryColorCssVar,
                    } as any
                  }
                />
                <span css={muiStyles.spanOverflow} style={secondaryColor ? {color: secondaryColor} : {}}>
                  {v.text}
                </span>
              </EntityLink>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
const getStyles: GetStylesFunction = (options) => {
  return {
    wrapper: css`
      border-radius: 16px;
      margin-bottom: 18px;
      padding: 8px 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      background: var(--dlBreadcrumbWrapperBackground);
    `,
    item: css`
      border-radius: 8px;
      background: var(--dlBreadcrumbBackground);
      color: var(--dlBreadcrumb);
      font-family: SourceSansPro-Bold;
      font-size: 18px;

      &:not([data-not-clickable='true']):hover {
        background: var(--dlBreadcrumbHoverBackground);
        color: var(--dlBreadcrumbHover);
        cursor: pointer;

        & button {
          cursor: pointer;
        }
        & svg {
          cursor: pointer;
        }
      }
      &[data-not-clickable][data-selected='true'] {
        margin-left: 8px;
        background: var(--dlBreadcrumbSelectedBackground);
        color: var(--dlBreadcrumbSelected);
        &:not([data-not-clickable='true']):hover {
          color: var(--dlBreadcrumbSelectedHover);
        }
      }
      & * {
        color: inherit !important;
      }
      & a {
        height: 64px;
        padding: 4px 4px 4px 12px;
        display: inline-flex !important;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        text-decoration: none !important;
      }
    `,
    joinerIconButton: css`
      padding: 0;
      color: #5d6f88;

      & svg {
        fill: none;
        font-size: 10px;
      }
    `,
    itemIconButton: css`
      padding: 0;
      color: var(--dlTheme-300);

      & svg {
        font-size: 18px;
      }
    `,
    spanOverflow: css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.1;
      padding-right: 18px;
    `,
  };
};
